import { Form } from 'react-bootstrap'

export const AdditionalConsentSubForm = ({ form: { values, handleChange } }) => {
    return (
        <>
            {
                values.additionalConsent.map((field, index) =>
                    <Form.Group className="mb-3" key={index}>
                        <Form.Check
                            id={field.displayName}
                            label={field.displayName}
                            onChange={(event) => {
                                field.onChange(event);
                                handleChange(event);
                            }}
                        />
                    </Form.Group>
                )
            }
        </>
    );
};